import { GroupsService } from "../services/groups/groups.service";
import { store } from "../store/store";

export const SET_GROUPS = 'SET_GROUPS';

export const fetchGroups = async () => {
    const res = await GroupsService.getGroups();
    store.dispatch(setGroups(res));
}

export const setGroups = (data: any) => {
    return {
        type: SET_GROUPS,
        data
    }
}
